import { useShop } from '../context/ShopContext';
import { formatRole } from '../utils/format';
import { LoadingState } from './Layout';

export function ShopSelector() {
  const { shops, selectedShopId, setSelectedShopId, loading, selectedShop } = useShop();

  if (loading) {
    return <LoadingState />;
  }

  if (shops.length === 0) {
    return null;
  }

  return (
    <div className="shop-selector">
      <label htmlFor="shop-select">Store</label>
      <select
        id="shop-select"
        value={selectedShopId ?? ''}
        onChange={(event) => setSelectedShopId(Number(event.target.value))}
      >
        {shops.map((entry) => (
          <option key={entry.shop.id} value={entry.shop.id}>
            {entry.shop.name}
          </option>
        ))}
      </select>
      {selectedShop && (
        <span className="shop-selector-role">{formatRole(selectedShop.role)}</span>
      )}
    </div>
  );
}

export function RequireShop({ children }) {
  const { selectedShopId, loading, shops } = useShop();

  if (loading) {
    return <LoadingState />;
  }

  if (shops.length === 0) {
    return (
      <EmptyState message="Create your store to continue." />
    );
  }

  if (!selectedShopId) {
    return <EmptyState message="Select a store above to continue." />;
  }

  return children;
}

function EmptyState({ message }) {
  return <div className="empty-state">{message}</div>;
}
